import useDebouncedEventListener from "@Hooks/eventListeners/useDebouncedEventListener";
import isEqual from "lodash/isEqual"
import {setPageLayout} from "@Reducers/pageSlice";
import {setFormVisibility} from "@Form/reducers/formSlice";
import determineScreenWidth from "@Reducers/functions/determineScreenWidth";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";

export default function useSetPageLayout() {
    const dispatch = useAppDispatch()
    const {
        isMobile,
        isTablet,
        isSmallTablet,
    } = useAppSelector((state) => state?.page)

    const currentState = {
        isMobile,
        isTablet,
        isSmallTablet,
    }

    const updateLayout = () => {
        if (!isEqual(currentState, determineScreenWidth())) {
            dispatch(setPageLayout(determineScreenWidth()))
            dispatch(setFormVisibility(false))
        }
    }

    useDebouncedEventListener("resize", updateLayout)
}